module.exports = __webpack_public_path__ + "static/media/import-top.c19f6db9.jpeg";